<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择门店:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <pd-shop-multiple-list
                v-model="filter.shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>任务名称：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
                class="form-item-value"
                v-model="filter.taskName"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>任务板块：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
                v-model="filter.forumId"
                :items="taskBlockList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
          <v-col cols="2" offset="1">
            <v-btn color="primary" class="mx-2" depressed @click="handleSearch">查询</v-btn>
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" depressed class="mr-2" @click="handleExport">导出</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:no-data> 查询出错或没有数据</template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import xjOrderApi from "@/api/pd/inspection/XjOrderApi";
import downloadUtil from "@/util/downloadUtil.js";

export default {
  name: "Pd-Manager-Xjorder-Transfer",
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      tab: null,
      filter: {
        taskName: undefined,
        pageNum: 1,
        pageSize: 15,
        forumId: ''
      },
      taskBlockList: [
        {id: 1, name: '工程'},
        {id: 2, name: '物业'}
      ],
      headers: [
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "任务名称",
          value: "taskName",
          sortable: false,
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "巡检开始日期",
          align: "start",
          sortable: false,
          value: "taskStartDate",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "巡检结束日期",
          align: "start",
          sortable: false,
          value: "taskEndDate",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "巡检时段",
          align: "start",
          sortable: false,
          value: "taskTime",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "发起人",
          align: "start",
          sortable: false,
          value: "createBy",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "接收人",
          align: "start",
          sortable: false,
          value: "receiverName",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "转单理由",
          align: "start",
          sortable: false,
          value: "transferReason",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "审批人",
          align: "start",
          sortable: false,
          value: "auditName",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "审批结果",
          align: "start",
          sortable: false,
          value: "statusName",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "发起时间",
          align: "start",
          sortable: false,
          value: "createTime",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "审批时间",
          align: "start",
          sortable: false,
          value: "auditTime",
          width: 120,
          divider: true,
          groupable: false
        }
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      checkId: null,
      btnDisabled: false
    };
  },
  mounted() {
    // this.getDataFromApi();
  },
  methods: {
    handleSearch() {
      if (!this.filter.shopIds || this.filter.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        taskName: undefined,
        pageNum: 1,
        pageSize: 15,
        forumId: ''
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getQueryParams(query) {
      return query;
    },
    async getDataFromApi() {
      this.loading = true;
      this.desserts = [];
      let me = this;
      let response = await xjOrderApi.listOrderTransfer(me.filter);
      console.log(response);
      let data = response.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取转单列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取转单列表失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    async handleExport() {
      if (!this.filter.shopIds || this.filter.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      let me = this;
      let shopIds = null;
      if (this.filter.shopIds && this.filter.shopIds.length > 0) {
        shopIds = me.filter.shopIds.join(',');
      }
      let res = await xjOrderApi.exportData({
        shopIds: shopIds,
        taskName: me.filter.taskName,
      });
      downloadUtil.downloadByBlob({res: res.data, fileName: "巡检转单记录导出数据.xlsx"});
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    }
  },
};
</script>